<!-- component for single message -->
<template>
  <div v-if="message.category === 'note'" class="message-note center my2 h5 gray-3 flex items-center">
    <div>
      {{message.message}}
      <div>{{ message.createdAt | dateAndTime }}</div>
    </div>
  </div>
  <div v-else :class="['flex', 'flex-wrap', 'message', 'mt1', messageClass]">
    <div class="timestamp h6 gray-3 col-12">{{ message.createdAt | time}}</div>
    <div v-if="message.type === 'text'" class="message-bubble" :class="categoryClass">{{ message.message }}</div>
    <div v-if="message.type === 'image'" class="message-bubble">
      <a @click="showImageModal" class="image-button">
        <img :src="imageUrl"/>
      </a>
      <modal
        v-show="isImageModalVisible"
        variant="media"
        @close="closeImageModal"
        :class="{fullscreen: true}"
      >
        <div class="media-container">
          <div class="media">
            <img :src="imageUrl"/>
            <v-button type="button" variant="icon" class="absolute top-0 right-0 m2" @click="closeImageModal">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g stroke="#FFF" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M.5.5l23 23M23.5.5l-23 23"/>
                </g>
              </svg>
            </v-button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>

import Util from '@/util';
import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';
import moment from 'moment';

export default {
    name: 'MessageItem',
    data () {
      return {
        isImageModalVisible: false,
      };
    },
    props: {
      message: Object,
      chat: Object,
    },
    components: {
      Modal,
      'v-button': Button
    },
    filters: {
      time(date) {
        if (!date) return '';
        const parsedDate = moment(date);
        return parsedDate.format('HH:mm');
      },
      dateAndTime (date) {
        if (!date) return '';
        const parsedDate = moment(date);
        const dateString = parsedDate.format('D.M.YYYY');
        const timeString = parsedDate.format('HH:mm');
        return `${dateString} klo ${timeString}`;
      }
    },
    methods: {
      showImageModal() {
        this.isImageModalVisible = true;
      },
      closeImageModal() {
        this.isImageModalVisible = false;
      },
    },
    computed: {
        messageClass() {
            if (!this.chat || !this.chat.userId) {
                return '';
            }
            if (this.message.userId !== this.chat.userId) {
                return 'message-self';
            }
            return '';
        },
        imageUrl() {
          if (!this.message.message) return '%23'
          return Util.getMessageImage(this.chat, this.message.message);
        },
        categoryClass () {
          return this.message.category
        },
    },
};
</script>

<style scoped>
  .message-bubble {
    padding: var(--space-2);
    background-color: var(--dark-blue);
    color: var(--white);
    font-size: var(--h5);
    border-radius: 0 20px 20px;
    max-width: 75%;
    white-space: pre-wrap;
  }

  .message.message-self {
    justify-content: flex-end;
  }

  .message.message-self .message-bubble {
    background-color: var(--gray);
    color: var(--dark-blue);
    border-radius: 20px 20px 0;
  }

  .message.message-self .timestamp {
    text-align: right;
  }

  .message-note::before,
  .message-note::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid var(--gray-3);
  }

  .message-note::before { margin-right: var(--space-3) }
  .message-note::after { margin-left: var(--space-3) }

  .image-button {
    display: block;
    max-width: 300px;
    cursor: pointer;
  }

  .image-button img {
    max-width: 100%;
    height: auto;
  }

  .media {
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
